import type { Snap, SnapActivity } from '@/types/database.types';
import RegularSnapCard from './snap/cards/RegularSnapCard';
import SystemSnapCard from './snap/cards/SystemSnapCard';
import InfluencerSnapCard from './snap/cards/InfluencerSnapCard';
import CashSnapCard from './snap/cards/CashSnapCard';

interface SnapCardProps {
  snap: Snap & { activity: SnapActivity };
  onDelete: (id: string) => void;
  onLike: (id: string, event: React.MouseEvent) => void;
  onVote?: (snapId: string, optionId: string) => void;
  onRemoveVote?: (snapId: string) => void;
  isVoting?: boolean;
}

export default function SnapCard({ snap, onDelete, onLike, onVote, onRemoveVote, isVoting }: SnapCardProps) {
  // CashSnap takes precedence over all other types
  if (snap.cashsnap) {
    return <CashSnapCard snap={snap} onDelete={onDelete} onLike={onLike} onVote={onVote} onRemoveVote={onRemoveVote} isVoting={isVoting} />;
  }
  
  // System SNAPs take precedence over influencer status
  if (snap.is_system) {
    return <SystemSnapCard snap={snap} onDelete={onDelete} onLike={onLike} onVote={onVote} onRemoveVote={onRemoveVote} isVoting={isVoting} />;
  }

  // Check for influencer status based on follower count
  if (snap.creator?.followers_count && snap.creator.followers_count >= 1000) {
    return <InfluencerSnapCard snap={snap} onDelete={onDelete} onLike={onLike} onVote={onVote} onRemoveVote={onRemoveVote} isVoting={isVoting} />;
  }

  // Default to regular SNAP card
  return <RegularSnapCard snap={snap} onDelete={onDelete} onLike={onLike} onVote={onVote} onRemoveVote={onRemoveVote} isVoting={isVoting} />;
}